/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Modal_Unavailable_DescriptionInputs */

const en_task_modal_unavailable_description = /** @type {(inputs: Task_Modal_Unavailable_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This activity could not be opened. It may have been removed, or it may no longer be assigned to you.`)
};

const pt_br2_task_modal_unavailable_description = /** @type {(inputs: Task_Modal_Unavailable_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível abrir esta atividade. Ela pode ter sido removida ou não estar mais atribuída a você.`)
};

/**
* | output |
* | --- |
* | "This activity could not be opened. It may have been removed, or it may no longer be assigned to you." |
*
* @param {Task_Modal_Unavailable_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_modal_unavailable_description = /** @type {((inputs?: Task_Modal_Unavailable_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Modal_Unavailable_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_modal_unavailable_description(inputs)
	return pt_br2_task_modal_unavailable_description(inputs)
});